import { Controller } from "@hotwired/stimulus"

// payment-gateway-form — shows only the selected provider's credential field
// group and hides the others.
//
// Markup (see app/views/settings/payment_gateways/_form.html.erb):
//   <form data-controller="payment-gateway-form">   <- controller on the FORM:
//     <select data-action="change->payment-gateway-form#providerChanged">
//     ...
//     <div data-payment-gateway-form-target="fields" data-provider="authorize_net">…</div>
//     <div data-payment-gateway-form-target="fields" data-provider="stripe">…</div>
//   </form>
//   data-action only binds INSIDE the controller element — scoping just the
//   credentials card left the select's change handler unbound in production.
//
// connect() applies the current selection so initial state matches the select.
export default class extends Controller {
  static targets = ["fields"]

  connect() {
    this.providerChanged()
  }

  providerChanged() {
    const provider = this._selectedProvider()
    this.fieldsTargets.forEach((group) => {
      group.classList.toggle("hidden", group.dataset.provider !== provider)
    })
  }

  _selectedProvider() {
    const select = document.querySelector(
      'select[name="payment_gateway[provider]"]'
    )
    return select ? select.value : null
  }
}
